module.exports = __webpack_public_path__ + "static/media/letterA.994eeadd.svg";